{
  "title": "Ice Knife",
  "source": "Xanathar's Guide to Everything",
  "levelAndSchool": "1st-level conjuration",
  "level": 1,
  "castingTime": "1 action",
  "range": "60 feet",
  "components": "S, M (a drop of water or piece of ice)",
  "duration": "Instantaneous",
  "description": [
    "You create a shard of ice and fling it at one creature within range. Make a ranged spell attack against the target. On a hit, the target takes 1d10 piercing damage. Hit or miss, the shard then explodes. The target and each creature within 5 feet of the point where the ice exploded must succeed on a Dexterity saving throw or take 2d6 cold damage.",
    "At Higher Levels. When you cast this spell using a spell slot of 2nd level or higher, the cold damage increases by 1d6 for each slot level above 1st."
  ],
  "spellLists": ["druid", "sorcerer", "wizard"]
}
